import styled from '@emotion/styled';
import { Theme } from 'ui_system/theme';

/*
 * NavLink styled component extracted to break circular dependency
 * between Header.js and HeaderMobileDropdown.js
 */
export const NavLink = styled.span`
  color: ${(props) =>
    props.color ? props.color : props.theme.headerLinkColor};
  cursor: pointer;
  margin-left: ${(props) => (props.marginLeft ? props.marginLeft : '0px')};
  margin-right: ${(props) => (props.marginRight ? props.marginRight : '0px')};
  text-decoration: none;

  &:hover,
  &:visited {
    color: ${(props) =>
      props.color ? props.color : props.theme.headerLinkColor};
    text-decoration: none;
  }

  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    ${(props) => props.hideMobile && 'display: none;'}
  }

  ${(props) => props.hideDesktop && 'display: none;'}

  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    ${(props) => props.hideDesktop && 'display: block;'}
  }

  i {
    font-size: 30px;
  }
`;
